import { styled } from '@uhg-abyss/web/tools/styled';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { Text } from '@uhg-abyss/web/ui/Text';

export const StyledSubTitle = styled(Text, {
  fontFamily: '$primary !important',
  fontWeight: 500,
  fontSize: '16px !important',
  lineHeight: '20px',
  color: '#323333 !important',
});
export const StyledModal = styled(ModalDialog, {
  '.abyss-modal-base-content-container': {
    width: '572px',
    zIndex: 999,
  },
});

export const StyledModelSection = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  padding: '0px 150px',
  '@media (max-width: 1024px)': {
    padding: '0px 100px',
  },
  '@media (max-width: 768px)': {
    padding: '24px',
  },
});
